export default __webpack_public_path__ + "media/images/features/toyono/main-f1612f04670817a9d7069c400852409a.png";